import { FormBase } from 'core/components';

export default class ReturnAddressForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'RETURNADDRESSFORM.SELLER',
				},
				{
					name: 'name',
					label: 'RETURNADDRESSFORM.NAME',
					rules: 'required',
				},
				{
					name: 'coreCountryId',
					label: 'RETURNADDRESSFORM.COUNTRY',
					rules: 'required',
				},
				{
					name: 'coreCountryStateId',
					label: 'RETURNADDRESSFORM.STATE',
					rules: 'required',
				},
				{
					name: 'address',
					fields: [
						{
							name: 'address1',
							label: 'RETURNADDRESSFORM.ADDRESS1',
							rules: 'required',
						},
						{
							name: 'address2',
							label: 'RETURNADDRESSFORM.ADDRESS2',
						},
						{
							name: 'address3',
							label: 'RETURNADDRESSFORM.ADDRESS3',
						},
						{
							name: 'city',
							label: 'RETURNADDRESSFORM.CITY',
							rules: 'required',
						},
						{
							name: 'zipCode',
							label: 'RETURNADDRESSFORM.ZIPCODE',
							rules: 'required',
						},
					],
				},
				{
					name: 'isDefaultReturnAddress',
					type: 'checkbox',
					label: 'RETURNADDRESSFORM.ISDEFAULTRETURNADDRESS',
				},
			],
		};
	}
}
